import React from "react";
import ComingSoon from "../../../components/comingSoon/ComingSoon";

const MockInterviewDashboard = () => (
  <ComingSoon
    content={
      <div className="text-left font-normal text-gray-800 text-sm sm:text-base">
        <h2 className="text-lg sm:text-xl font-semibold mb-2">
          Coming Soon: Mock Interview Practice — Ace Your Next Interview
        </h2>
        <p className="mb-6">Practice interviews with AI-powered feedback to boost your confidence and performance.</p>
        
        <p className="font-semibold mb-2">What It Will Do</p>
        <ul className="list-disc pl-5 space-y-4">
          <li>
            <p>
              <strong>AI-Powered Mock Interviews</strong><br />
              Practice with realistic interview questions tailored to your target career and experience level.
            </p>
          </li>
          <li>
            <p>
              <strong>Real-Time Feedback</strong><br />
              Get instant feedback on your answers, body language, and communication skills.
            </p>
          </li>
          <li>
            <p>
              <strong>Performance Analytics</strong><br />
              Track your progress with detailed analytics and improvement suggestions.
            </p>
          </li>
          <li>
            <p>
              <strong>Customizable Scenarios</strong><br />
              Choose from different interview types, industries, and difficulty levels.
            </p>
          </li>
        </ul>

        <p className="font-semibold mb-2 mt-6">Features Coming Soon</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>Voice and video interview practice</li>
          <li>Industry-specific question banks</li>
          <li>Behavioral and technical interview modes</li>
          <li>Performance tracking and progress reports</li>
          <li>Personalized improvement recommendations</li>
        </ul>
      </div>
    }
  />
);

export default MockInterviewDashboard; 